import axios from "axios";
import React, { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import ImageDrawer from "components/ui/image-drawer";
import moment from "moment";
import { Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import Loading from "components/ui/loading";
import { loadFavAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import AlertConfirm from "components/ui/alert-confirm";
import { DrawerProduct } from "components/product-of-week/drawer-product";

const cookies = new Cookies();

export default function ReviewManagement() {
  const history = useHistory();
  const dispatch = useDispatch();

  const no = cookies.get("no");

  let favInfo = cookies.get("favInfo");
  const { favAlertOpen } = useSelector((state) => state.top);
  const storeCode = favInfo
    ? favInfo.visibleTp == "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [listData, setListData] = useState([]);
  const [alertMode, setAlertMode] = useState("");
  const [open, setOpen] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [delData, setDelData] = useState("");
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [flyer, setFlyer] = useState([]);
  const [token, setToken] = useState("");

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadList();
    loadFlyer();
  }, []);

  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const loadList = async () => {
    await axios
      .get(`/api/eh/product-review/my`, { params: { tp: favInfo.visibleTp } })
      .then((res) => {
        setListData(res.data.data.productReviewList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const loadUrl = async () => {
    await axios
      .get(`/api/sm/store/get/${storeCode}`)
      .then((res) => {
        location.href = `${res.data.data.store.ebookUrlApp}`;
      })
      .catch((error) => {});
  };

  const removeReview = () => {
    axios
      .post(`/api/eh/product-review/remove`, null, {
        params: { seq: delData.seq },
      })
      .then((res) => {
        handleAlertClose();
        loadList();
      });
  };

  const loadFlyer = () => {
    let localToken = cookies.get("X-AUTH-TOKEN");

    axios
      .get(`/api/sm/store/get-leaflet/${localToken ? storeCode : "2701"}`)
      .then((res) => {
        setFlyer(res.data.data);
      })
      .catch((error) => {});
  };

  const moveToRecommend = () => {
    if (token && !storeCode) dispatch(loadFavAlert(true));
    else handleDrawerHighOpen();

    // if (storeCode) {
    //   loadUrl();
    // } else {
    //   dispatch(loadFavAlert(true));
    // }
  };

  window.appBackKeyHandle = () => {
    if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else if (drawerHigh) {
      handleDrawerHighClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <div className="reviewManagement">
        {listData.number > 0 ? (
          <ul className="review-list">
            {listData.list.map((item, i) => (
              <li key={i} className="review-item">
                <div className="top">
                  <div className="main-img">
                    <div className="img-wrap">
                      <img src={item.prodImgUrl} />
                    </div>
                  </div>
                  <div className="tit">{item.pdTtl}</div>
                </div>

                <div className="content">{item.cont}</div>
                {item.imgUrl1 && (
                  <div className="img">
                    <ImageDrawer item={item} />
                  </div>
                )}
                <div className="bottom">
                  <div className="date">
                    {moment(item.rgstYmd).format("YYYY.MM.DD(ddd)")}
                  </div>
                  <div className="func-btn">
                    <div className="textBtn">
                      <Button
                        size="small"
                        color="info"
                        onClick={() => {
                          history.push({
                            pathname: `/my-review/detail/${item.seq}`,
                            props: {
                              seq: item.seq,
                              prodImgUrl: item.prodImgUrl,
                              pdTtl: item.pdTtl,
                            },
                          });
                        }}
                      >
                        수정
                      </Button>
                      <Button
                        size="small"
                        color="info"
                        onClick={() => {
                          setDelData(item);
                          setAlertMode("delete");
                          setOpen(true);
                        }}
                      >
                        삭제
                      </Button>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="nodata">
            <Box className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
            </Box>
            <p className="color-info">작성한 상품리뷰가 없습니다</p>
          </div>
        )}

        <div className="recommend">
          <p>
            {listData && listData.number == 0 ? (
              <>
                BEST 추천상품 구매 시 리뷰 작성 가능!
                <br />
                리뷰 쓰고 100 포인트 받으세요!
              </>
            ) : (
              <>
                BEST 추천상품 더 쇼핑하고
                <br />
                리뷰 포인트까지!
              </>
            )}
          </p>
          <Button
            variant="outlined"
            color="primary"
            className="btn-rounded end-icon"
            size="small"
            endIcon={<i className="ico-go" />}
            onClick={() => {
              // moveToRecommend();
              history.push("/product-of-week");
            }}
          >
            추천상품 보기
          </Button>
        </div>

        {alertMode == "delete" && (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"해당 리뷰를 삭제하시겠습니까?"}
            action={() => {
              removeReview();
            }}
          />
        )}
        <DrawerProduct
          flyer={flyer}
          drawerHigh={drawerHigh}
          handleDrawerHighClose={handleDrawerHighClose}
        />
      </div>
    </>
  );
}
